import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AmusementComplex`;


const ApiAmusementComplex = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  get: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.get(url);
  },
  create: (params) => {
    const url = `${baseServiceUrl}/create-AmusementComplex`;
    return ServiceApi.post(url, params);
  },
  update: (id, params) => {
    const url = `${baseServiceUrl}/update-AmusementComplex`;
    return ServiceApi.put(url, params);
  },
  delete: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.delete(url);
  },
  getAmusementComplexCacheToken: () => {
    const url = `${baseServiceUrl}/getAmusementComplexCacheToken`;
    return ServiceApi.get(url);
  },
  getAmusementComplexes: () => {
    const url = `${baseServiceUrl}/getAmusementComplexes`;
    return ServiceApi.get(url);
  },
};

export default ApiAmusementComplex;


